<template>
    <div class="withdraw">
        <Top name="提现" back email></Top>
        <div class="withdraw_w">
           <div class="withdraw_w_t">
                <h3>${{balance}}</h3>
                <!-- 提现方式 Tab 切换 -->
                <div class="withdraw-tabs">
                    <div
                        class="tab-item"
                        :class="{ active: form.withdrawMethod === 'paydify' }"
                        @click="switchMethod('paydify')"
                    >
                        <span class="tab-icon">💰</span>
                        <span class="tab-text">USDT/USDC</span>
                    </div>
                    <div
                        class="tab-item"
                        :class="{ active: form.withdrawMethod === 'waffo' }"
                        @click="switchMethod('waffo')"
                    >
                        <span class="tab-icon">🏦</span>
                        <span class="tab-text">法币</span>
                    </div>
                    <div
                        class="tab-item"
                        :class="{ active: form.withdrawMethod === 'onerway' }"
                        @click="switchMethod('onerway')"
                    >
                        <span class="tab-icon">💳</span>
                        <span class="tab-text">法币(Onerway)</span>
                    </div>
                </div>
                <van-form class="form_w">
                    <!-- 一键选用已保存的提现配置(与后端 WithdrawConfig 同源) -->
                    <div class="cfg-section" v-if="currentConfigs.length">
                        <div class="cfg-title">
                            选择提现配置
                            <span class="cfg-manage" @click="goConfig">管理配置</span>
                        </div>
                        <div
                            class="cfg-card"
                            v-for="item in currentConfigs"
                            :key="item.id"
                            :class="{ active: selectedConfigId === item.id }"
                            @click="selectConfig(item)"
                        >
                            <div class="cfg-head">
                                <span class="cfg-tag" :class="item.pay_type">
                                    {{ ['waffo', 'onerway'].includes(form.withdrawMethod) ? (item.country_name + ' ' + item.currency) : (item.currency + ' ' + item.network) }}
                                </span>
                                <span class="cfg-label">{{ item.label || defaultConfigLabel(item) }}</span>
                                <span class="cfg-check" v-if="selectedConfigId === item.id">✓</span>
                            </div>
                            <div class="cfg-sub">{{ configSummary(item) }}</div>
                        </div>
                    </div>
                    <div class="cfg-none" v-else>
                        还没有可用的提现配置，
                        <span class="cfg-link" @click="goConfig">去添加</span>
                    </div>

                    <!-- 提现提示 -->
                    <div class="cfg-hint" v-if="form.withdrawMethod === 'waffo'">
                        <div class="hint-title">💡 Waffo 提现说明</div>
                        各国银行卡必填信息(银行代码/支行号/账户类型/地址等)已在提现配置中校验，
                        选择配置后输入金额与支付密码即可提交。
                    </div>
                    <div class="cfg-hint onerway-hint" v-if="form.withdrawMethod === 'onerway'">
                        <div class="hint-title">💡 Onerway 提现说明</div>
                        <p>• 必填项：收款人邮箱 + 银行信息（账号/姓名/银行代码等）</p>
                        <p>• 选填项：SWIFT Code、银行地址（国际转账时建议填写）</p>
                        <p>• 提示：所有必填信息已在配置中验证，确保快速出款</p>
                    </div>

                    <van-field v-model="form.money" label="" class="money_inp1" :disabled="['waffo', 'onerway'].includes(form.withdrawMethod) && waffoDisabled" autocomplete="off" auto-complete="new-password" :placeholder="moneyPlaceholder" @input="handlerInp" @blur="handlerBlur" />
                    <van-field v-model="form.password" type="password" :disabled="['waffo', 'onerway'].includes(form.withdrawMethod) && waffoDisabled" autocomplete="off" auto-complete="new-password" label="" placeholder="请输入支付密码" />
                </van-form>
                <router-link :to="{ name: 'Passwordset', params: { active: 1}}" class="orange">忘记密码</router-link>
           </div>
           <div class="withdraw_btn">
               <van-button round type="info" size="large" :disabled="disabled || (['waffo', 'onerway'].includes(form.withdrawMethod) && waffoDisabled)" color="linear-gradient(to right, #FF704D, #F73727)" @click="onSubmit">
                   申请提现
               </van-button>
           </div>
           <div class="withdraw_line"></div>
           <div class="withdraw_w_c">
               <!-- 通用规则 -->
               <div class="withdraw_item">
                   <span>提现手续费怎么收取？</span>
                   <!-- <p v-if="servicePer != 0">答：每笔提现收取{{servicePer}}%作为手续费，最低{{serviceMin}}最高{{serviceMax}}；</p> -->
                   <p>答：提现不收取手续费。</p>
               </div>
               <div class="withdraw_item">
                   <span>提现限额为多少？</span>
                   <p>答：单笔提现最低 $10，最高 $50000，24小时内提现一次。</p>
               </div>

               <!-- USDT/USDC 提现规则 -->
               <template v-if="form.withdrawMethod === 'paydify'">
                   <div class="withdraw_item">
                       <span>支持哪些币种和网络？</span>
                       <p>答：USDT 支持 BSC/SOL/ETH/TRON 网络；USDC 支持 BSC/SOL/BASE/ETH 网络。USDT/USDC 均按 1:1 扣减账户余额。</p>
                   </div>
                   <div class="withdraw_item">
                       <span>提现到账时间？</span>
                       <p>答：审核通过后链上转账，通常几分钟至 1 小时内到账。</p>
                   </div>
                   <div class="withdraw_item">
                       <span>注意事项？</span>
                       <p>答：请务必确认钱包地址与所选链网络匹配，填错可能导致资产丢失且无法找回。</p>
                   </div>
               </template>

               <!-- 银行卡提现规则 -->
               <template v-else>
                   <div class="withdraw_item">
                       <span>支持哪些国家和收款方式？</span>
                       <p>答：{{ supportedCountryText }}。仅支持银行卡收款。</p>
                   </div>
                   <div class="withdraw_item">
                       <span>到账金额怎么计算？</span>
                       <p>答：提现金额以美元计价，按提交申请时的实时汇率折算成当地币种出款，具体到账金额以收款账户为准。</p>
                   </div>
                   <div class="withdraw_item">
                       <span>提现到账时间？</span>
                       <p>答：审核通过后发起出款，通常几分钟至 1 个工作日到账。</p>
                   </div>
               <div class="withdraw_item">
                   <span>注意事项？</span>
                   <p>答：收款人姓名须与收款账户实名一致，否则可能出款失败；各国差异化必填项(如日本支行号/手机号、美国账户类型/地址、菲律宾BRSTN银行代码)已在提现配置中校验，请妥善维护。</p>
               </div>
               </template>
           </div>
        </div>
    </div>
</template>
<script>
 import Top from '@/components/top'

export default {
    name: 'Withdraw',
    components: {
        Top,
    },
    data() {
        return {
            balance: '',
            waffoDisabled: false, // waffo 银行卡提现暂不可用
            // 已保存的提现收款配置(WithdrawConfig/list 下发)与当前选中项
            // paydify/waffo 均走配置一键选用，不再支持页面内手动填写
            configs: [],
            selectedConfigId: 0,
            form: {
                // 提现方式: paydify=USDT/USDC 链上, waffo=海外银行卡
                withdrawMethod: 'paydify',

                // Waffo 银行卡提现：收款信息统一在提现配置中维护(见 WithdrawConfig 页)，
                // 此处仅一键选用，不再收集手动表单

                // 通用字段
                money: '',
                password: '',
            },
            // Waffo 收款国家列表：由后端 Transfer/waffoConfig 接口下发(见 created() -> getWaffoConfig)，
            // 与后端 config('app')['transfer']['waffo']['countries'] 保持单一数据源，避免前后端配置漂移
            waffoCountries: [],
            isNumberTrue: false,
            servicePer: 0,
            serviceMin: 0,
            serviceMax: 0,
            disabled: false
        }
    },
    computed: {
        //当前提现方式下可选的配置
        currentConfigs() {
            return this.configs.filter(item => item.pay_type === this.form.withdrawMethod);
        },
        moneyPlaceholder() {
            if (this.form.withdrawMethod === 'paydify') {
                const cfg = this.currentConfigs.find(c => c.id === this.selectedConfigId);
                return cfg ? ('请输入提现金额(' + cfg.currency + ')') : '请输入提现金额';
            }
            // 银行卡提现按美元计价申请，出款时按实时汇率折算当地币种
            return '请输入提现金额(USD)';
        },
        supportedCountryText() {
            return '当前支持' + this.waffoCountries.map(item => item.text).join('、');
        }
    },
    created() {
        this.form.money = this.form.money.split('.')[0];
        //获取账户余额
        this.getBalance();
        //获取交易规则信息
        this.getRule();
        //获取 Waffo 提现支持的收款国家列表(规则说明用)
        this.getWaffoConfig();
        //获取已保存的提现收款配置
        this.loadConfigs();
    },
    beforeRouteEnter(to, from, next) {
        // 从配置页返回时刷新配置列表
        next(vm => vm.loadConfigs());
    },
    methods: {
        //获取已保存的提现配置
        loadConfigs() {
            this.$api.account.getWithdrawConfigList().then(res => {
                if (res.code == 200) {
                    this.configs = res.data.list || [];
                }
            }).catch(err => {
                console.log(err);
            });
        },
        //选中提现配置
        selectConfig(item) {
            this.selectedConfigId = this.selectedConfigId === item.id ? 0 : item.id;
        },
        //跳转配置管理页
        goConfig() {
            this.$router.push({ name: 'WithdrawConfig' });
        },
        defaultConfigLabel(item) {
            return ['waffo', 'onerway'].includes(item.pay_type)
                ? (item.country_name + '银行卡')
                : (item.currency + '钱包');
        },
        configSummary(item) {
            if (['waffo', 'onerway'].includes(item.pay_type)) {
                let bank = '银行代码 ' + item.bank_code;
                if (item.extra && item.extra.bankBranch) {
                    bank += ' / 支行 ' + item.extra.bankBranch;
                }
                return bank + ' · ' + this.maskNo(item.payout_account_no) + ' · ' + item.payee_name;
            }
            return this.maskNo(item.payout_account_no || item.wallet_address);
        },
        maskNo(no) {
            no = String(no || '');
            if (no.length <= 8) return no;
            return no.substring(0, 4) + '****' + no.substring(no.length - 4);
        },
        //获取交易规则信息
        getRule() {
            this.$api.sale.getRule().then(res => {
                if (res.code == 200) {
                    this.servicePer = res.data.servicePer;
                    this.serviceMin = res.data.serviceMin;
                    this.serviceMax = res.data.serviceMax;
                }
            });
        },
        //获取 Waffo 提现支持的收款国家列表
        getWaffoConfig() {
            this.$api.account.getWaffoConfig().then(res => {
                if (res.code == 200) {
                    this.waffoCountries = res.data.countries || [];
                }
            }).catch(err => {
                console.log(err);
            });
        },
        //切换提现方式
        switchMethod(method) {
            if (this.form.withdrawMethod === method) return;

            // 如果切换到 waffo/onerway 且暂不可用，提示用户
            if (['waffo', 'onerway'].includes(method) && this.waffoDisabled) {
                this.$toast({
                    message: '法币提现正在开通中',
                    duration: 2000
                });
            }

            this.form.withdrawMethod = method;
            // 切换时清空表单与已选配置，避免把上一种方式的收款信息带过去
            this.resetForm();
        },
        //重置(清空金额/密码与已选配置)
        resetForm() {
            this.selectedConfigId = 0;
            this.form.money = '';
            this.form.password = '';
        },
        //输入金额改变
        handlerInp(val) {
            this.form.money = val;
            this.clearNoNum(this.form);
        },
        //输入金额失去焦点
        handlerBlur() {
            this.form.money = Number(this.form.money);
            this.moneyCompare();
        },
        //提现金额判断
        moneyCompare() {
            this.isNumberTrue = false;
            if (parseFloat(this.form.money) >= 10) {
                if (parseFloat(this.form.money) <= 50000) {
                    if (parseFloat(this.form.money) <= parseFloat(this.balance)) {
                        this.isNumberTrue = true;
                    }else{
                        this.$toast({
                            message: '余额不足',
                            duration: 1500
                        });
                    }
                }else{
                    this.$toast({
                        message: '单笔最高 50000',
                        duration: 1500
                    });
                }
            }else{
                this.$toast({
                    message: '单笔最低 $10',
                    duration: 1500
                });
            }
            return this.isNumberTrue;
        },
        //只能输入整数和小数，保留两位小数
        clearNoNum(obj) {
            if (!/^(\d+|\d*\.(\d{2}|\d{1}))$/.test(Number(obj.money))) {
                obj.money = obj.money.replace(/[^\d.]/g, "");
                if (obj.money.indexOf('.') > -1 && obj.money.split('.').length == 2) {
                    if (obj.money.split('.')[1].length > 2) {
                        obj.money = obj.money.substring(0, obj.money.length - 1);
                    }
                }else{
                    obj.money = obj.money.substring(0, obj.money.length - 1);
                }
            }
        },
        //申请提现
        onSubmit() {
            if (this.disabled) {
                this.$toast({
                    duration: 1500,
                    message: '操作过于频繁，请稍后再试'
                });
                return false;
            }

            // 两种方式均一键选用已保存配置，必须先选择
            if (!this.selectedConfigId) {
                this.$toast({ message: '请选择提现配置', duration: 1500 });
                return false;
            }

            let returnVal = this.moneyCompare();
            if (!returnVal) {
                return false;
            }
            if (this.form.money != '' && this.form.password != '') {
                if (this.isNumberTrue) {
                    this.withdraw();
                    this.disabled = true;
                    setTimeout(() => {
                        this.disabled = false;
                    }, 2000);
                }
            }else{
                this.$toast({
                    message: '请先填完输入框',
                    duration: 1500
                });
            }
        },
        //获取账户余额
        getBalance() {
            let username = localStorage.getItem('username');
            this.$api.account.getBalance({username:username}).then((res)=>{
                if (res.code == 200) {
                    this.balance = res.data.accountBalance;
                }
            }).catch(err => {
                console.log(err);
            });
        },
        //发起提现请求
        withdraw() {
            // paydify/waffo 均一键选用已保存配置，收款字段由后端从配置注水
            let params = {
                pay_type: this.form.withdrawMethod,
                config_id: this.selectedConfigId,
                money: this.form.money,
                pay_password: this.form.password,
            };

            let tips = this.form.withdrawMethod === 'paydify'
                ? '提现申请已提交，系统将在24小时内审核。审核通过后发起链上转账，通常几分钟至1小时到账。审核及到账结果将以站内信通知。'
                : '提现申请已提交，系统将在24小时内审核。审核通过后按当时汇率折算成当地币种出款，通常几分钟至1个工作日到账。审核及到账结果将以站内信通知。';

            this.$api.account.withdraw(params).then(res => {
                if (res.code == 200) {
                    this.$dialog.alert({
                        title: '',
                        message: tips,
                    });
                    this.resetForm();
                }
                this.getBalance();
            }).catch(err => {
                console.log(err);
            });
        }
    },
}
</script>
<style scoped>
.withdraw_w_t{
    padding: .6875rem 0 .625rem;
    overflow: hidden;
    border-bottom: 1px solid #dedede;
}
.withdraw_w_t h3{
    padding: 0 1.1875rem;
    color: #ff4e00;
    font-size: 1rem;
    line-height: 3.46875rem;
    border-bottom: 1px solid #dedede;
    position: relative;
}
.withdraw_w_t h3::before{
    content: '余额：';
    position: absolute;
    left: 1.1875rem;
    top: 50%;
    transform: translate(0, -50%);
    color: #707070;
}

/* 提现方式 Tab 样式 */
.withdraw-tabs{
    display: flex;
    margin: .8125rem 1.1875rem 0;
    border-radius: 5px;
    overflow: hidden;
    border: 1px solid #dedede;
}
.withdraw-tabs .tab-item{
    flex: 1;
    padding: .5rem 0;
    text-align: center;
    background-color: #efefef;
    color: #707070;
    font-size: .75rem;
}
.withdraw-tabs .tab-item.active{
    background-color: #fff;
    color: #ff4e00;
    font-weight: bold;
}
.withdraw-tabs .tab-icon{
    margin-right: .25rem;
}
.form_w{
    margin: .8125rem 1.1875rem .3125rem;
}
.form_w .van-cell{
    background-color: #efefef;
    margin-bottom: .78125rem;
    border-radius: 5px;
}
.withdraw_w_t a{
    font-size: .71875rem;
    line-height: 1.8em;
    float: right;
    margin-right: 1.1875rem;
    color: #227eeb;
    text-decoration: underline;
}
.withdraw_line{
    height: .46875rem;
    background-color: #ececec;
    border-bottom: 1px solid #dedede;
}
.withdraw_w_c{
    padding: .9375rem 1.1875rem;
    border-bottom: 1px solid #dedede;
    text-align: left;
    font-size: .75rem;
    line-height: 1.8em;
    color: #313131;
}
.withdraw_w_c .withdraw_item{
    margin-bottom: .9375rem;
}
.withdraw_w_c .withdraw_item:last-child{
    margin-bottom: 0;
}
.withdraw_w_c .withdraw_item p{
    color: #909090;
}
.withdraw_btn{
    margin: 10% 10% 0;
    padding: 10% 0;
}
.withdraw_btn button{
    font-size: 1.2rem;
}
/* 提现配置一键选择 */
.cfg-section{
    margin-bottom: .78125rem;
    text-align: left;
}
.cfg-title{
    font-size: .78rem;
    color: #707070;
    margin-bottom: .4rem;
    padding: 0 .3rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.cfg-manage{
    color: #227eeb;
    text-decoration: underline;
    font-size: .72rem;
}
.cfg-card{
    background: #efefef;
    border: 1px solid transparent;
    border-radius: 5px;
    padding: .55rem .75rem;
    margin-bottom: .5rem;
}
.cfg-card.active{
    border-color: #ff4e00;
    background: #fff7f4;
}
.cfg-head{
    display: flex;
    align-items: center;
}
.cfg-tag{
    background: #ff4e00;
    color: #fff;
    font-size: .62rem;
    border-radius: 3px;
    padding: .08rem .35rem;
    margin-right: .45rem;
    white-space: nowrap;
}
.cfg-tag.paydify{
    background: #227eeb;
}
.cfg-label{
    flex: 1;
    font-size: .78rem;
    color: #313131;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.cfg-check{
    color: #ff4e00;
    font-weight: bold;
    margin-left: .4rem;
}
.cfg-sub{
    font-size: .7rem;
    color: #909090;
    margin-top: .3rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.cfg-none{
    background: #efefef;
    border-radius: 5px;
    padding: .7rem .5rem;
    font-size: .78rem;
    color: #707070;
    margin-bottom: .78125rem;
    text-align: center;
}
.cfg-link{
    color: #ff4e00;
    text-decoration: underline;
}
.cfg-hint{
    background: #fff7f4;
    border-radius: 5px;
    padding: .6rem .7rem;
    font-size: .7rem;
    color: #909090;
    text-align: left;
    line-height: 1.6em;
    margin-bottom: .78125rem;
    border-left: 3px solid #ff4e00;
}
.cfg-hint.onerway-hint{
    background: #f0f7ff;
    border-left-color: #227eeb;
}
.hint-title{
    font-size: .75rem;
    font-weight: bold;
    color: #313131;
    margin-bottom: .4rem;
}
.cfg-hint p{
    margin: .25rem 0;
    padding-left: .5rem;
}
/* waffo 禁用时的样式 */
.form_w .van-field--disabled .van-field__control{
    color: #c8c9cc;
    -webkit-text-fill-color: #c8c9cc;
}
</style>
<style>
.form_w .van-field__control{
    text-align: center;
    font-size: .8125rem;
}
.money_inp1 .van-field__body{
    position: relative;
}
</style>
